import { render, staticRenderFns } from "./InputFuneral.vue?vue&type=template&id=56590a42&scoped=true&"
import script from "./InputFuneral.vue?vue&type=script&lang=js&"
export * from "./InputFuneral.vue?vue&type=script&lang=js&"
import style0 from "./InputFuneral.vue?vue&type=style&index=0&id=56590a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56590a42",
  null
  
)

export default component.exports